import { COMPANY_STATUS } from '@demandproai/shared';
import LoggedInUserService from '../services/AuthService'

const useCertifiedLifecareCompany = () => {
    const user = LoggedInUserService.GetLoggedInUserData();
    const isCertifiedLifecareCompany = user?.companyStatus === COMPANY_STATUS.PLANNER;
    return isCertifiedLifecareCompany;
};

export default useCertifiedLifecareCompany;
